export const ERROR_ORIGIN_DIMENSION = 'errorOrigin';
export const BROWSER_EXTENSION_ERROR_ORIGIN = 'browserExtension';
export const THIRD_PARTY_LIBRARY_ERROR_ORIGIN = 'thirdPartyLibrary';
export const THIRD_PARTY_SCRIPT_ERROR_ORIGIN = 'thirdPartyScript';
export const UNATTRIBUTABLE_ERROR_ORIGIN = 'unattributable';
